<style>
main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2rem;
  background: #fff;
}

.table {
  width: 100%;
  table-layout: auto;
}

.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.pdf-modal-content {
  width: 90%;
  height: 90%;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  background: #f8f9fa;
}

.pdf-header h4 {
  margin: 0;
  font-size: 1.2rem;
}

.pdf-controls {
  display: flex;
  gap: 0.5rem;
}

.btn-download, .btn-close {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.btn-download {
  background: #007bff;
  color: white;
}

.btn-download:hover {
  background: #0056b3;
}

.btn-close {
  background: #dc3545;
  color: white;
  font-weight: bold;
}

.btn-close:hover {
  background: #c82333;
}

.pdf-viewer-container {
  flex: 1;
  overflow: hidden;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
}

</style>
<template>
  <main>
      <h3>Στρατιωτικά Δημοσιεύματα (ΣΔΗΜ)</h3>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">Α/Α</th>
        <th scope="col">ΑΡΙΘΜΟΣ</th>
        <th scope="col">ΕΤΟΣ ΕΚΔΟΣΗΣ</th>
        <th scope="col">ΤΙΤΛΟΣ</th>
        <th scope="col">ΔΙΕΥΘΥΝΣΗ ΕΚΔΟΣΗΣ</th>
        <th scope="col">ΑΝΑΓΝΩΣΗ</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(kanonismos, index) in kanonismoi" :key="kanonismos.id">
        <th scope="row">{{ index + 1 }}</th>
        <td>{{ kanonismos.code }}</td>
        <td>{{ kanonismos.publishedYear }}</td>
        <td>{{ kanonismos.title }}</td>
        <td>{{ kanonismos.department }}</td>
        <td>
          <button @click="openPdfViewer(kanonismos)">Ανάγνωση</button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- PDF Viewer Modal -->
  <div v-if="showPdfViewer" class="pdf-modal" @click.self="closePdfViewer">
    <div class="pdf-modal-content">
      <div class="pdf-header">
        <h4>{{ currentPdfTitle }}</h4>
        <div class="pdf-controls">
          <button @click="closePdfViewer" class="btn-close">✕</button>
        </div>
      </div>
      <div class="pdf-viewer-container">
        <iframe :src="pdfUrl" class="pdf-iframe" frameborder="0"></iframe>
      </div>
    </div>
  </div>

  </main>
</template>

<script>

export default {
  data() {
    return {
      kanonismoi: [],
      showPdfViewer: false,
      pdfUrl: null,
      currentPdfTitle: '',
      currentPdfBlob: null,
      currentKanonismos: null
    }
  },
  methods: {
    getKanonismoi() {
      this.$http.get('/kanonismoi/get-all')
          .then(response => {
            this.kanonismoi = response.data;
          })
          .catch(e => {
            console.error(e);
          });
    },
    async openPdfViewer(kanonismos) {
      try {
        const response = await this.$http.post('/kanonismoi/get-kanonismos', kanonismos.id, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        this.currentPdfBlob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(this.currentPdfBlob);
        this.currentPdfTitle = `${kanonismos.code}.pdf`;
        this.currentKanonismos = kanonismos;
        this.showPdfViewer = true;
      } catch (e) {
        console.error('Error loading PDF:', e);
      }
    },
    closePdfViewer() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      this.showPdfViewer = false;
      this.pdfUrl = null;
      this.currentPdfBlob = null;
      this.currentKanonismos = null;
    },
    downloadPdf() {
      if (this.currentPdfBlob && this.currentKanonismos) {
        const url = URL.createObjectURL(this.currentPdfBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.currentKanonismos.code}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    }
  },
  mounted() {
    this.getKanonismoi();
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  }
}
</script>
